import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getDatabase } from 'firebase/database';
import { getAuth,signInAnonymously } from 'firebase/auth';
const firebaseConfig = {
  apiKey: "AIzaSyAi5pKxAYeZYVqFs9StQCKamBsJXvi2cVg",
  authDomain: "value-logistic-7f5d6.firebaseapp.com",
  databaseURL: "https://value-logistic-7f5d6-default-rtdb.firebaseio.com",
  projectId: "value-logistic-7f5d6",
  storageBucket: "value-logistic-7f5d6.firebasestorage.app",
  messagingSenderId: "515519191576",
  appId: "1:515519191576:web:79c742f69035701deb416d",
  measurementId: "G-4VDMC3PKEH"
};


const app = initializeApp(firebaseConfig);
const realtimeDb = getDatabase(app);
const firestoreDb = getFirestore(app);
const auth = getAuth(app);
export { realtimeDb, firestoreDb, auth,signInAnonymously };

